import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { compose } from 'redux';
import { FamilyConnectPopup } from './containers/FamilyConnectPopup';
import { RootFamilyPage } from './containers/RootFamilyPage';
import { FamilyBeelineModal } from '../Home/containers/FamilyWithBeeline/components/FamilyBeelineModal';
import { withViewAnalytics } from '../../utils/hocs/withViewAnalytics';

const Family = () => {
  const [isPopupOpen, setPopupState] = useState(false);
  const { personalInfo, info } = useSelector((state) => state.home.personalFamily);
  const isAddNumberWay = (personalInfo !== undefined) && isPopupOpen;

  return (
    <>
      <RootFamilyPage {...{ setPopupState }} />
      {isAddNumberWay ? (
        <FamilyBeelineModal
          isPopupOpen={isPopupOpen}
          setPopupState={setPopupState}
          popupContent={personalInfo?.popupContent}
          invitedNumbers={info?.invites}
        />
      ) : <FamilyConnectPopup />}
    </>
  );
};

export default compose(
  withViewAnalytics,
)(Family);
